import { render, staticRenderFns } from "./JVxeSubPopover.vue?vue&type=template&id=abaa7cb2&scoped=true&"
import script from "./JVxeSubPopover.vue?vue&type=script&lang=js&"
export * from "./JVxeSubPopover.vue?vue&type=script&lang=js&"
import style0 from "./JVxeSubPopover.vue?vue&type=style&index=0&id=abaa7cb2&scoped=true&lang=less&"
import style1 from "./JVxeSubPopover.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaa7cb2",
  null
  
)

export default component.exports